export const InoutEN = {
	"reasonInout": {
		"title": "Manager check in/check out reason",
		"breadCrumb": "Manager check in/check out reason",
		"pageHeader": {
			"reasonInout": "Manager check in/check out reason"
		}
	}
}
